import { FA_GLYPHS } from './icon-glyphs';

export type IconName = keyof typeof FA_GLYPHS;

/** Font units per em in the Font Awesome 4 font; its baseline sits 256 units above the bottom. */
const EM = 1792;
const DESCENT = 256;

/**
 * A Font Awesome 4 icon as inline SVG (`<i class="fa fa-…">` in the legacy portal): one em high,
 * as wide as the glyph, in the current text colour. Decorative unless `title` is given.
 */
export function Icon({
  name,
  title,
  spin = false,
  className = '',
}: {
  name: IconName;
  /** Accessible name; without it the icon is hidden from assistive technology. */
  title?: string;
  /** Rotate continuously (`fa-spin`), for `spinner` and `refresh`. */
  spin?: boolean;
  className?: string;
}) {
  const [width, d] = FA_GLYPHS[name];
  return (
    <svg
      viewBox={`0 ${-DESCENT} ${width} ${EM}`}
      fill="currentColor"
      role={title ? 'img' : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      data-icon={name}
      className={`inline-block h-[1em] shrink-0 align-[-0.125em] ${spin ? 'animate-spin' : ''} ${className}`}
      style={{ width: `${width / EM}em` }}
    >
      <path transform={`matrix(1 0 0 -1 0 ${EM - 2 * DESCENT})`} d={d} />
    </svg>
  );
}
